import type { Block, ParagraphData } from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";
import "./step.css";

export default function StepView({
  block,
  stepNumber = "1.",
}: {
  block: Block;
  stepNumber?: string;
}) {
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-step">
      <span className="pdf-step__num">{stepNumber}</span>

      <span className="pdf-step__text">
        {(data.textParts || []).map((part, i) => {
          if (part.type === "text") return <span key={i}>{part.value}</span>;

          return (
            <RefLink
              key={i}
              targetId={part.targetId}
              label={part.label}
              className="pdf-ref-link text-primary"
            />
          );
        })}
      </span>
    </div>
  );
}
